export default function SelectIcon() {
  return (
    <svg
      width="25"
      height="12"
      viewBox="0 0 35 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9492 1.25757C19.1641 1.42944 19.1641 1.77319 18.9492 1.98804L9.96875 10.9685C9.75391 11.1833 9.45312 11.1833 9.23828 10.9685L0.257812 1.98804C0.0429688 1.77319 0.0429688 1.42944 0.257812 1.25757L1.07422 0.398193C1.28906 0.18335 1.63281 0.18335 1.80469 0.398193L9.625 8.17554L17.4023 0.398193C17.5742 0.18335 17.918 0.18335 18.1328 0.398193L18.9492 1.25757Z"
        fill="currentColor"
      />
    </svg>
  )
}
